import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Page Not Found</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        The page you were searching for could not be found.
        <br />
        Please contact Pointguard at <a href='mailto:info@pointguard.se'>info@pointguard.se</a>{' '}
        <br />
        to let us know what you clicked to get here.
      </div>
    </>
  )
}

export {Error404}
